import { environment } from '../../environments/environment';

export class ServiceConstant {
  public static baseUrl = environment.apiBaseUrl;
  public static webSocketUrl = environment.webSocketUrl;
  /** Gateway version prefix: `/v2` in dev, staging and prod (FNF-259, FNF-738). */
  public static apiPrefix = `/${environment.apiVersion}`;
  /** `baseUrl` plus the gateway version; gateway calls append their path to this. */
  public static apiUrl = `${environment.apiBaseUrl}/${environment.apiVersion}`;
}
